import type { StatCardProps } from "@/components/molecules/StatCard";
import { MessageText } from "iconsax-react";

export interface MessagesType {
  id: string;
  ID: string;
  type: string;
  sender: string;
  recipient: string;
  preview: string;
  status: "Sent" | "Pending" | "Flagged";
  date: string;
}

export interface Broadcast {
  id: string;
  ID: string;
  channel: string;
  audience: string;
  preview: string;
  status: "Sent" | "Pending" | "Failed";
  date: string;
}

export interface Notification {
  id: string;
  ID: string;
  channel: string;
  event: string;
  preview: string;
  status: "Sent" | "Pending" | "Failed";
}

export const MESSAGES_STATS: StatCardProps[] = [
  {
    title: "Total Messages",
    value: "25,430",
    icon: <MessageText variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "User-to-User Messages",
    value: "25,430",
    icon: <MessageText variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "System Notifications",
    value: "25,430",
    icon: <MessageText variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Broadcasts Sent",
    value: "430",
    icon: <MessageText variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Failed Deliveries",
    value: "220",
    icon: <MessageText variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+0.5%", type: "increase" },
  },
];

export const MESSAGESNOTIFICATIONS_TABLE_HEADERS = [
  "ID",
  "Type",
  "Sender",
  "Recipient(s)",
  "Preview",
  "Status",
  "Date",
  "",
];

export const BROADCAST_TABLE_HEADERS = [
  "ID",
  "Channels",
  "Audience",
  "Preview",
  "Status",
  "Date",
  "",
];

export const NOTIFICATIONS_TABLE_HEADERS = [
  "ID",
  "Channel(s)",
  "Event Trigger",
  "Preview",
  "Status",
  "",
];

export const MOCK_MESSAGES: MessagesType[] = [
  {
    id: "1",
    ID: "MSG-0001",
    type: "User Message",
    sender: "@sarah_p",
    recipient: "@jane_smith",
    preview: "“See you at 7 pm 😉”",
    status: "Sent",
    date: "2 Mar 2025",
  },
  {
    id: "2",
    ID: "NOT-0345",
    type: "System Notification",
    sender: "System",
    recipient: "All Users",
    preview: "“Your profile has been verified 🎉”",
    status: "Sent",
    date: "2 Mar 2025",
  },
  {
    id: "3",
    ID: "BRC-0012",
    type: "Admin Broadcast",
    sender: "@sarah_p",
    recipient: "NY City Users",
    preview: "“Join our March Singles Meetup”",
    status: "Pending",
    date: "2 Mar 2025",
  },
  {
    id: "4",
    ID: "MSG-0002",
    type: "User Message",
    sender: "@davidk",
    recipient: "@markcode",
    preview: "“Send me your number”",
    status: "Flagged",
    date: "2 Mar 2025",
  },
];

export const MOCK_BROADCASTS: Broadcast[] = [
  {
    id: "1",
    ID: "BRC-010",
    channel: "In-App, Push",
    audience: "NY City",
    preview: "“March Singles Meetup…”",
    status: "Sent",
    date: "2 Mar 2025",
  },
  {
    id: "1",
    ID: "BRC-010",
    channel: "In-App, Push",
    audience: "NY City",
    preview: "“March Singles Meetup…”",
    status: "Sent",
    date: "2 Mar 2025",
  },
];

export const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: "1",
    ID: "R-010",
    channel: "In-App, Push",
    event: "New Match Found",
    preview: "“March Singles Meetup…”",
    status: "Sent",
  },
  {
    id: "2",
    ID: "R-010",
    channel: "In-App, Push",
    event: "Group Expiry Warn",
    preview: "“Your group will expire in 1 hr”",
    status: "Sent",
  },
];
